// @flow
import {
  ADMIN_SET_FACEBASE_LIST,
  ADMIN_ADD_FACEBASE,
  ADMIN_UPDATE_FACEBASE,
  ADMIN_REMOVE_USER_FROM_FACEBASE,
  ADMIN_REMOVE_LICENCE_FROM_FACEBASE,
  ADMIN_DELETE_FACEBASE,
  ADMIN_UPDATE_FACEBASE_USER
} from "../../global/actions/actionNames";

const initialState = {
  facebaseList: null
};

const facebaseReducers = (state: Object = initialState, actions: Object): * => {
  switch (actions.type) {
    case ADMIN_SET_FACEBASE_LIST:
      let facebaseList =
        state.facebaseList === null ? {} : { ...state.facebaseList };
      if (actions.facebases !== null) {
        for (let i = 0; i < actions.facebases.length; i++) {
          facebaseList[actions.facebases[i].uuid] = actions.facebases[i];
        }
      }
      return {
        ...state,
        facebaseList: facebaseList
      };

    case ADMIN_ADD_FACEBASE:
      if (actions.facebase !== null) {
        let facebaseList = { ...state.facebaseList };
        facebaseList[actions.facebase.uuid] = actions.facebase;
        return {
          ...state,
          facebaseList: facebaseList
        };
      }
      return state;

    case ADMIN_UPDATE_FACEBASE:
      if (actions.facebase !== null) {
        let facebaseList = { ...state.facebaseList };
        let facebase = { ...facebaseList[actions.facebase.uuid] };
        facebaseList[actions.facebase.uuid] = {
          ...facebase,
          ...actions.facebase
        };
        return {
          ...state,
          facebaseList: facebaseList
        };
      }
      return state;

    case ADMIN_REMOVE_USER_FROM_FACEBASE:
      if (actions.userId !== null && actions.facebaseId !== null) {
        let facebaseList = { ...state.facebaseList };
        let facebase = { ...facebaseList[actions.facebaseId] };
        let users = [...facebase.users];
        if (users.length > 0) {
          let index = users.findIndex(x => x.uuid === actions.userId);
          if (index > -1) {
            users.splice(index, 1);

            facebase.users = users;
            facebaseList[actions.facebaseId] = facebase;
            return {
              ...state,
              facebaseList: facebaseList
            };
          }
        }
      }
      return state;

    case ADMIN_REMOVE_LICENCE_FROM_FACEBASE:
      if (actions.licenceId !== null && actions.facebaseId !== null) {
        let facebaseList = { ...state.facebaseList };
        let facebase = { ...facebaseList[actions.facebaseId] };
        let licences = [...facebase.licences];
        if (licences.length > 0) {
          let index = licences.findIndex(x => x.uuid === actions.licenceId);
          if (index > -1) {
            licences.splice(index, 1);
          }
        }
        facebase.licences = licences;
        facebaseList[actions.facebaseId] = facebase;
        return {
          ...state,
          facebaseList: facebaseList
        };
      }
      return state;

    case ADMIN_DELETE_FACEBASE:
      if (actions.facebaseUuid !== null && state.facebaseList) {
        let facebaseList = { ...state.facebaseList };
        delete facebaseList[actions.facebaseUuid];
        return {
          ...state,
          facebaseList: facebaseList
        };
      }
      return state;

    case ADMIN_UPDATE_FACEBASE_USER:
      if (actions.user !== null && actions.facebaseId !== null) {
        let facebaseList = { ...state.facebaseList };
        let facebase = { ...facebaseList[actions.facebaseId] };
        let users = [...facebase.users];
        if (users.length > 0) {
          let index = users.findIndex(x => x.uuid === actions.user.cognitoUuid);
          if (index > -1) {
            users[index] = actions.user;
          } else {
            users.push({ node: actions.user });
          }
        } else {
          users.push({ node: actions.user });
        }
        facebase.users = users;
        facebaseList[actions.facebaseId] = facebase;
        return {
          ...state,
          facebaseList: facebaseList
        };
      }
      return state;

    default:
      return state;
  }
};
export default facebaseReducers;
